import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { AdminTabs } from "../components/admin/AdminTabs";

const fail = (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail));

const InviteForm = ({ onDone }) => {
  const [f, setF] = useState({ name: "", email: "" });
  const [busy, setBusy] = useState(false);
  const submit = (e) => {
    e.preventDefault();
    setBusy(true);
    api.post("/admin/team/invite", f).then(({ data }) => { toast.success(`Set-up link emailed to ${data.email}.`); setF({ name: "", email: "" }); onDone(); })
      .catch(fail).finally(() => setBusy(false));
  };
  const input = "w-full rounded-sm border border-stone-300 bg-white px-3 py-2 text-sm";
  return (
    <form onSubmit={submit} data-testid="team-invite-form" className="bg-white border border-stone-200 rounded-md p-6 grid sm:grid-cols-3 gap-4 items-end">
      <label className="text-sm">Name<input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={input} data-testid="team-invite-name" /></label>
      <label className="text-sm">Email<input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={input} data-testid="team-invite-email" /></label>
      <button type="submit" disabled={busy} className="btn-primary" data-testid="team-invite-submit">{busy ? "Sending…" : "Send set-up link"}</button>
    </form>
  );
};

const Row = ({ m, onChanged }) => {
  const resend = () => api.post("/admin/team/invite", { name: m.name, email: m.email }).then(() => toast.success("Set-up link sent again.")).catch(fail);
  const remove = () => window.confirm(`Remove admin access for ${m.name}?`) &&
    api.post(`/admin/team/${m.id}/remove`).then(() => { toast.success("Access removed."); onChanged(); }).catch(fail);
  return (
    <tr className="border-b border-stone-200" data-testid={`team-row-${m.email}`}>
      <td className="py-3 pr-4">{m.name}{m.is_you && " (you)"}</td>
      <td className="py-3 pr-4">{m.email}</td>
      <td className="py-3 pr-4" data-testid={`team-status-${m.email}`}>{m.mfa_enabled ? "Active" : m.invited_by ? "Invited - not set up yet" : "2-step login not set up yet"}</td>
      <td className="py-3 text-right space-x-3 whitespace-nowrap">
        {!m.mfa_enabled && m.invited_by && <button type="button" onClick={resend} className="underline text-bronze-dark" data-testid={`team-resend-${m.email}`}>Resend link</button>}
        {!m.is_you && <button type="button" onClick={remove} className="underline text-red-700" data-testid={`team-remove-${m.email}`}>Remove access</button>}
      </td>
    </tr>
  );
};

export default function AdminTeam() {
  const [team, setTeam] = useState(null);
  const load = useCallback(() => { api.get("/admin/team").then(({ data }) => setTeam(data.team)).catch(fail); }, []);
  useEffect(load, [load]);
  return (
    <div className="container-ccc py-12 space-y-8" data-testid="admin-team-page">
      <div>
        <h1 className="font-serif text-4xl">Admin team</h1>
        <AdminTabs active="/admin/team" />
        <p className="mt-4 text-sm text-ink-muted max-w-2xl">Everyone listed has full admin access. New people get an email link to choose a password, then set up 2-step login on first sign-in. The link expires after 72 hours.</p>
      </div>
      <InviteForm onDone={load} />
      <table className="w-full text-sm" data-testid="team-table">
        <thead><tr className="text-left border-b border-stone-300"><th className="py-2">Name</th><th>Email</th><th>Status</th><th /></tr></thead>
        <tbody>{(team || []).map((m) => <Row key={m.id} m={m} onChanged={load} />)}</tbody>
      </table>
    </div>
  );
}
